export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/sfio5nMTtdMQFgmLKeBBxC/Logo_(1)_1.png'

// Original generated background: distributed network routes along the lower band and far-left
// edge, small orange/green junction segments, quiet charcoal elsewhere. No text, people, or UI.
export const HERO_BG_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/dd3d7f45-a859-4916-9184-a97671726fab.jpg'

export const PORTFOLIO_URL =
  'https://www.websiteforge.com/custom-website-design-examples.html'

export const CUSTOMER_STORIES_URL =
  'https://www.websiteforge.com/Satisfied_Website_Customers.html'

export const PHONE_DISPLAY = '231-266-0606'
export const PHONE_HREF = 'tel:+12312660606'
export const SALES_EMAIL = 'sales@websiteforge.com'

export const navLinks = [
  { label: 'What we handle', href: '#services' },
  { label: 'Ecommerce', href: '#ecommerce' },
  { label: 'Our work', href: '#work' },
  { label: 'Support', href: '#support' },
]

// Header-only navigation (in-page destinations). Footer keeps `navLinks`.
export const headerNavLinks = [
  { label: 'Home', href: '#top' },
  { label: 'Solutions', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Why WebsiteForge', href: '#why-websiteforge' },
  { label: 'How Pricing Works', href: '#pricing' },
]

export const trustPoints = [
  {
    title: 'Since 2002',
    body: 'Experience across multiple generations of web technology.',
  },
  {
    title: '1,000+ websites',
    body: 'Custom builds, rebuilds, ecommerce stores, and long-term client work.',
  },
  {
    title: '100+ integrations',
    body: 'CRM, accounting, scheduling, inventory, billing, and other business systems.',
  },
  {
    title: '0% WebsiteForge transaction fees',
    body: 'Your processor charges its rate. WebsiteForge does not add a percentage of each order.',
  },
]

export const services = [
  {
    id: 'found',
    title: 'Get found.',
    body: 'Reach customers through search and social advertising, then bring them to pages that make responding easy.',
    line: 'SEO · Google Ads · Facebook & Instagram',
  },
  {
    id: 'convert',
    title: 'Turn interest into business.',
    body: "Make it easy to ask, book, request a quote, or buy. Follow up so inquiries don't go cold.",
    line: 'Custom websites · Ecommerce · Chat & lead follow-up',
  },
  {
    id: 'busywork',
    title: 'Cut the busywork.',
    body: 'Connect the systems you already use and automate the repeated tasks that slow your team down.',
    line: 'AI assistance · CRM · Billing & integrations',
  },
]

export const expertiseRows = [
  {
    id: 'stand',
    title: 'See where you stand.',
    body: 'We check actual search rankings and study the competitors ahead of you.',
  },
  {
    id: 'improve',
    title: 'Make the improvements.',
    body: 'We turn the research into better pages, technical fixes, and clearer paths to an inquiry or sale.',
  },
  {
    id: 'changed',
    title: 'Know what changed.',
    body: "Monthly reports show the work completed, the results we're tracking, and what we'll tackle next.",
  },
]

export const automationSteps = [
  {
    id: 'capture',
    title: 'Capture and respond.',
    body: 'Forms, live chat, and AI-assisted answers help customers take the next step, with clear handoffs to your team.',
  },
  {
    id: 'moving',
    title: 'Keep the sale moving.',
    body: 'Connect quote requests, bookings, and follow-up around your sales process.',
  },
  {
    id: 'twice',
    title: 'Stop entering everything twice.',
    body: 'Link your CRM, billing, scheduling, and order systems so information moves where it needs to go.',
  },
]

export const ecommerceBenefits = [
  'Product options, bundles, and made-to-order items.',
  'Customer pricing, wholesale accounts, and quote-to-order.',
  'Connected inventory, payments, and fulfillment.',
]

export const projects = [
  {
    name: 'Down Home Interiors',
    category: 'Interior design & retail',
    image: 'https://www.websiteforge.com/uploaded/images/portfolio/2026/DownHome.png',
  },
  {
    name: 'Walkers Martial Arts',
    category: 'Classes & enrollment',
    image:
      'https://www.websiteforge.com/uploaded/images/portfolio/2026/Walkers%20Martial%20arts.png',
  },
  {
    name: 'Precision Pro Sprayers',
    category: 'Industrial equipment',
    image: 'https://www.websiteforge.com/uploaded/images/portfolio/2026/Percision.png',
  },
]

export const supportColumns = [
  {
    id: 'upkeep',
    title: 'We handle the upkeep.',
    body: 'Managed hosting, SSL, backups, monitoring, and content changes.',
  },
  {
    id: 'improving',
    title: 'We keep improving.',
    body: 'SEO updates, campaign and conversion improvements, monthly reporting, and clear next steps.',
  },
  {
    id: 'grow',
    title: 'We grow with you.',
    body: 'New chat flows, integrations, and automation as your business needs change.',
  },
]

// Exact excerpts from testimonials published on https://www.websiteforge.com/
export const testimonials = [
  {
    quote: "The support I've received from Website Forge has been great.",
    name: 'Bruce Oliver',
  },
  {
    quote: 'We have since built several successful websites together.',
    name: 'Ginger Rushing',
  },
]

export const buyerQuestions = [
  {
    q: 'Can you work with my existing website?',
    a: "We'll review what you have and recommend what to keep, improve, connect, or rebuild.",
  },
  {
    q: 'Do I have to manage the website myself?',
    a: 'No. Send the changes you need and our team handles the work included in your plan.',
  },
  {
    q: 'How is pricing worked out?',
    a: 'We agree on scope and pricing before work begins. Ongoing work, larger projects, ad spend, and third-party costs are clearly separated.',
  },
]
